export enum LanguageEnum {
    DE = 'de',
    EN_US = 'en_us',
    EN_GB = 'en_gb',
    ES = 'es',
    FR = 'fr',
    IT = 'it',
    NO = 'no',
    NL = 'nl',
    PT = 'pt',
    SV = 'sv'
}
